module.exports = __webpack_public_path__ + "media/images/athletes/3549-b0a075d666b146cfcff2edc82a8eac22.png";